export default function normalizeURLInput(inputText?: string): string | undefined {
  if (!inputText) return inputText;

  const trimmedInput = inputText.trim();
  if (!trimmedInput) return "";

  if (trimmedInput.startsWith("//")) {
    return `https:${trimmedInput}`;
  }

  if (/^[a-z][a-z\d+.-]*:\/\//i.test(trimmedInput)) {
    return trimmedInput;
  }

  return `https://${trimmedInput}`;
}